import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FiTrendingUp, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { caseStudies } from '../../data/caseStudies';

const CaseStudySection = ({ limit = 3, city = null }) => {
  const displayStudies = city 
    ? caseStudies.filter(s => s.tags.includes(city) || s.tags.includes('Alberta'))
    : caseStudies.slice(0, limit);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-orange-600 font-bold uppercase tracking-wider text-sm mb-4">Proven Results</h2>
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900">Real Results for Alberta Contractors</h3>
          </div>
          <Link 
            to="/case-studies" 
            className="inline-flex items-center gap-2 text-slate-900 font-bold border-b-2 border-orange-500 pb-1 hover:text-orange-600 transition-colors"
          >
            View All Success Stories <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {displayStudies.map((study, i) => (
            <motion.div 
              key={study.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="group bg-slate-50 rounded-3xl p-8 border border-slate-100 hover:border-orange-500 hover:bg-white hover:shadow-2xl transition-all"
            >
              <div className="flex justify-between items-start mb-6">
                <span className="text-xs font-bold px-3 py-1 bg-white border border-slate-200 rounded-full text-slate-500 uppercase tracking-tighter">
                  {study.industry}
                </span>
                <div className="w-10 h-10 bg-orange-600 text-white rounded-lg flex items-center justify-center shadow-lg shadow-orange-600/20">
                  <SafeIcon icon={FiTrendingUp} />
                </div>
              </div>
              <h4 className="text-sm font-black text-orange-600 mb-2">{study.client}</h4>
              <h3 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-orange-600 transition-colors">
                {study.title}
              </h3>
              <div className="space-y-4 mb-8">
                <div>
                  <p className="text-[10px] uppercase font-bold text-slate-400 mb-1">The Result</p>
                  <p className="text-sm font-bold text-slate-900 italic">"{study.result}"</p>
                </div>
              </div>
              <Link 
                to={`/case-studies/${study.id}`}
                className="flex items-center gap-2 text-orange-600 font-bold text-sm"
              >
                View Strategy <SafeIcon icon={FiArrowRight} />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudySection;